<template>
<div v-if="params.st">
    <div v-if="this.processingApi" class="div-invite-spin">
        <div class="loader-wheel" :class="{ 'loader-wheel-black': $store.state.template.style.defaultTextColor }"></div>
        <h2 class="loader-text" :class="defaultTextColor"></h2>
    </div>

    <div v-else-if="statusInviteMsg" class="div-invite">
        <p class="convite-text" :class="defaultTextColor" style="white-space: pre-line;"> {{ statusInviteMsg.replace('Agradeçemos', 'Agradecemos') }} </p>
    </div>

    <div v-else-if="showRefuseConfirmation" class="div-invite">
        <p class="convite-text" :class="defaultTextColor"> {{ inviteName ? `Olá ${inviteName}` : 'Olá' }}, por favor confirme que não poderá comparecer: </p>
        <div>
            <button class="button-st-white" @click="confirmRefuse()"> Confirmo que NÃO poderei comparecer</button>
            <button class="button-st d-block" @click="redirectHome()"> Quero participar</button>
        </div>
    </div>

    <div v-else-if="showGuests" class="div-invite">
        <div>
            <h4 :class="defaultTextColor" class="mb-3 text-left" style="font-size: 1.35rem !important;">
                <span v-if="companionQt">
                    {{ inviteName ? `Olá ${inviteName}` : 'Olá' }}, você recebeu um convite que permite trazer mais
                    {{ companionQt }}
                    {{ companionQt > 1 ? 'convidados' : 'convidado' }}.
                </span>
                <span v-else>
                    {{ inviteName ? `Olá ${inviteName}` : 'Olá' }}, você recebeu um convite individual.
                </span>
                <span v-if="respFromCheckInvite.statusGuests.length">
                    Aqui estão mais informações:
                </span>
            </h4>
            <div v-for="(guest, index) in respFromCheckInvite.statusGuests" :key="index" :class="defaultTextColor" class="mb-3 text-left">
                <p class="mb-1 text-first-color">
                    {{ guest.nome }}
                </p>

                <span v-if="guest.status !== 1" class="mb-0">
                    <!-- icons -->
                    <i class="fa fa-exclamation-circle mr-2 text-yellow" /> Confirmação pendente <br>
                    <template v-if="template.finalSurvey10.registerBiometry">
                        <i class="fa fa-exclamation-circle mr-2 text-yellow" /> Biometria pendente <br>
                    </template>
                    <!-- Init guest registers links -->
                    <template v-if="guest.nome !== inviteName">
                        Por favor,
                        <span class="mb-1 c-link" @click="redirectToCheckInfos(guest.surveyLink)">
                            inicie o cadastro de {{ guest.nome.split(' ')[0] }}
                        </span>
                        ou
                        <span class="mb-1 c-link d-block" @click="shareLinkToSurvey(guest.surveyLink, guest.nome)" data-toggle="modal" data-target="#modalWhatsAppToRegister">
                            envie o link de cadastro para {{ guest.nome.split(' ')[0] }}.
                        </span>
                    </template>
                    <!-- Init main register button -->
                    <button v-else class="mt-3 mx-auto button-st-white-init d-block" @click="redirectHome()">
                        Iniciar meu cadastro
                    </button>
                </span>
                <span v-else-if="template.finalSurvey10.registerBiometry && guest.biometry === 0" class="mb-3">
                    <i class="fa fa-check-circle mr-2 text-green-light-1" /> Confirmação realizada <br>
                    <i class="fa fa-exclamation-circle mr-2 text-yellow" /> Biometria pendente <br>
                    Por favor,
                    <span class="mb-1 c-link" @click="loadBiometry(guest.surveyUserId)">
                        cadastre a biometria de {{ guest.nome.split(' ')[0] }}
                        <span v-if="loadingBiometry" class="ml-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </span>
                    ou
                    <span class="mb-1 c-link d-block" @click="shareLinkToBiometry(guest.surveyUserId, guest.nome)" data-toggle="modal" data-target="#modalWhatsAppToBiometry">
                        envie o link de cadastro de biometria para {{ guest.nome.split(' ')[0] }}.
                    </span>
                </span>
                <span v-else-if="template.finalSurvey10.registerBiometry && guest.biometry === 1">
                    <i class="fa fa-check-circle mr-2 text-green-light-1" /> Confirmação realizada <br>
                    <i class="fa fa-check-circle mr-2 text-green-light-1" /> Biometria realizada <br>
                </span>
                <span v-else-if="finalVoucherHasToBeShown && guest.status === 1">
                    <i class="fa fa-check-circle mr-2 text-green-light-1" /> Confirmação realizada <br>
                    <span class="mb-3 c-link" @click="redirectToCheckInfos(guest.surveyLink)">
                        {{ guest.nome !== inviteName ? `Confira a confirmação de ${guest.nome.split(' ')[0]} por aqui.` : 'Confira aqui suas informações.' }}
                    </span>
                </span>
            </div>

            <!-- add new guest button -->
            <p v-if="invitesQtLeft" :class="defaultTextColor" class="mt-5 mb-3 text-left">
                Você tem direito a trazer mais {{ invitesQtLeft }} {{ invitesQtLeft > 1 ? 'convidados' : 'convidado' }}
            </p>
            <button v-if="invitesQtLeft" class="mt-3 mx-auto button-st-white-init d-block" @click="addGuest()">
                Adicionar novo convidado
            </button>
        </div>
    </div>

    <!-- addGuestForm -->
    <div v-else-if="showAddGuestForm" class="div-invite">
        <h4 id="intro" class="mt-3 mb-2 text-second-color extra-bold mt-lg-0 c-intro">
            Adicionar novo convidado
        </h4>

        <div class="col-md-12 px-0">
            <!-- guest name -->
            <div class="form-group my-4 my-md-0">
                <label class="form-group has-float-label">
                    <input type="text" :class="defaultTextColor" class="form-control form-control-home fcmobile" id="guestName" placeholder="Nome e Sobrenome" v-model="guestName" />
                    <span :class="defaultTextColor" for="guestName">Nome do convidado</span>
                </label>

                <button class="btn btn-home btn-block mt-4 mb-2 btn-validate" ref="btnStart" :style="
              template.style.homeBtnColor
                ? { backgroundColor: template.style.homeBtnColor }
                : ''
            " @click="validateGuestForm" :disabled="processingApi">
                    Enviar
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="processingApi"></span>
                </button>
            </div>
        </div>
    </div>

    <!-- Modal: Share Biometry link -->
    <div class="modal fade" id="modalWhatsAppToBiometry" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle"><i class="fa fa-link mr-2" /> Compartilhar Link</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <span v-if="loadingBiometryToWhats" class="d-flex justify-content-center py-4">
                    Carregando
                    <span class="ml-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </span>
                <div v-else-if="biometryData" class="py-4">
                    <div class="w-100 text-center px-3">
                        <p class="mb-1">
                            Clique para copiar
                        </p>
                        <textarea id="copyInput" readonly type="text" rows="1" class="mb-2 copy-input" :value="sharingUrlInput" @click="iosCopyToClipboard($event.target)" />
                        </div>
            <div class="w-100 text-center">
              <p class="mb-1">
                Ou
              </p>
              <ShareNetwork
                network="whatsapp"
                class="btn-whats"
                tag="button"
                :url="sharingUrl"
                :title="sharingMsg"
                :description="template.home.title"
              >
                Envie pelo WhatsApp
                <img
                  src="static/assets/img/ic-wp-black.png"
                  style="width: 20px"
                  class="mb-1"
                  alt="WhatsApp"
                />
              </ShareNetwork>
            </div>
          </div>
          <p v-else class="text-center py-4">
            {{ biometryApiMsg }}
          </p>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary py-2" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Share Survey link -->
    <div class="modal fade" id="modalWhatsAppToRegister" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle"><i class="fa fa-link mr-2" />Compartilhar Link</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="py-4">
            <div class="mb-3 px-3 w-100 text-center">
              <p class="mb-1 text-center">
                Clique para copiar
              </p>
              <textarea
                id="copyInput2"
                readonly
                type="text"
                rows="1"
                class="mb-2 copy-input"
                :value="sharingUrlInput"
                @click="iosCopyToClipboard($event.target)"
              />
            </div>
            <div class="w-100 text-center">
              <p class="mb-1 text-center">
                Ou
              </p>
              <ShareNetwork
                network="whatsapp"
                class="btn-whats"
                tag="button"
                :url="sharingUrl"
                :title="sharingMsg"
                :description="template.home.title"
              >
                Envie pelo WhatsApp
                <img
                  src="static/assets/img/ic-wp-black.png"
                  style="width: 20px"
                  class="mb-1"
                  alt="WhatsApp"
                />
              </ShareNetwork>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary py-2" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
    Survey
} from "../services/Survey.js";

const surveyService = new Survey();

export default {
    name: "HomeType10",
    components: {},
    props: {
        params: {
            required: true,
            type: Object
        },
        id: {
            required: true,
            type: Object
        },
        prj: {
            required: true,
            type: Object
        },

    },
    data: () => ({
        popupUseActive: false,
        popupPrivActive: false,
        processingApi: false,
        cpf: "",
        phone: "",
        statusInvite: "",
        statusInviteMsg: "",
        refuse: false,
        respFromCheckInvite: null,

        showRefuseConfirmation: false,
        showGuests: false,

        showAddGuestForm: false,
        guestName: '',

        loadingBiometry: false,
        biometryData: '',
        biometryApiMsg: '',
        loadingBiometryToWhats: false,
        sharingMsg: '',
        sharingUrl: '',
        sharingUrlInput: ''
    }),
    computed: {
        defaultTextColor() {
            return this.$store.state.template.style.defaultTextColor ? this.$store.state.template.style.defaultTextColor : 'text-white'
        },
        inviteName() {
            return this.respFromCheckInvite.inviteName
        },
        inviteId() {
            return this.params.inv
        },
        inviteToBeAnswered() {
            return this.respFromCheckInvite.statusRegister === 0 || this.respFromCheckInvite.statusRegister === 2
        },
        inviteConfirmed() {
            return this.respFromCheckInvite.statusRegister === 1
        },
        inviteRefused() {
            return this.respFromCheckInvite.statusRegister === 3
        },
        userWantsToRefuse() {
            return this.params.refuse
        },
        userHasOneInvite() {
            return this.respFromCheckInvite.qtInv === 1
        },
        userHasMultipleInvites() {
            return this.respFromCheckInvite.qtInv > 1
        },
        finalVoucherHasToBeShown() {
            return !this.template.finalSurvey10.registerBiometry
        },
        companionQt() {
            return this.respFromCheckInvite.qtInv - 1
        },
        pluralIfManyCompanions() {
            return this.companionQt > 1 ? 's' : ''
        },
        invitesQtLeft() {
            return this.respFromCheckInvite.qtInv - this.respFromCheckInvite.statusGuests.length
        },
        biometryToBeRegister() {
            return this.respFromCheckInvite.statusGuests.some(obj => obj.biometry === 0)
        },
        template() {
            return this.$store.state.template;
        }
    },
    mounted() {
        this.checkGlobal()
        this.checkRefuse()
        this.saveUrlHome()
    },
    methods: {
        saveUrlHome() {
            const currentUrl = window.location.href;
            const newUrl = currentUrl.replace(/#\/home/g, '');
            const regex = /[?&]p=([^&]+)/;

            let noIsInvited = regex.test(currentUrl);

            if (noIsInvited == true) {
                this.$store.commit("SET_urlCompleteHomeType10", newUrl);
                localStorage.setItem('homeUrlType10', newUrl);
            }
        },
        checkGlobal() {
            if (this.params.g) {
                this.redirectHome()
            }
        },
        checkRefuse() {
            if (this.userWantsToRefuse || this.params.st) {
                this.checkInvite()
            } else {
                this.redirectHome()
            }
        },
        async confirmRefuse() {
            this.processingApi = true;
            try {
                const ret = await surveyService.RefuseInvite(this.id, this.prj, this.params)
                this.statusInviteMsg = ret.header.msg;
                this.processingApi = false;

            } catch (err) {
                this.processingApi = false;
                this.$vs.notify({
                    color: "rgb(255, 130, 0)",
                    title: 'Recebemos um erro:',
                    text: `${err}.`,
                    time: 11000
                })
            }
        },
        async checkInvite() {
            this.processingApi = true;
            try {
                const ret = await surveyService.CheckInvite(this.id, this.prj, this.params)
                if (ret.header.codigo) {
                    this.respFromCheckInvite = ret.data
                    this.$store.commit('SET_InviteName', ret.data.inviteName)
                    this.$store.commit('SET_Invite', ret.data)

                    // userHasOneInvite
                    if (this.userHasOneInvite && !this.userWantsToRefuse) {
                        if (this.inviteConfirmed && !this.finalVoucherHasToBeShown) {
                            this.showGuests = true
                        } else {
                            this.redirectHome()
                        }
                    } else

                        // userWantsToRefuse
                        if (this.userWantsToRefuse) {
                            if (this.inviteConfirmed || this.inviteRefused) {
                                this.statusInviteMsg = this.respFromCheckInvite.message
                            } else if (this.inviteToBeAnswered) {
                                this.showRefuseConfirmation = true
                            }
                        } else

                            // userHasMultipleInvites
                            if (this.userHasMultipleInvites) {
                                if (this.inviteRefused) {
                                    this.statusInviteMsg = this.respFromCheckInvite.message
                                } else if (this.inviteToBeAnswered || this.inviteConfirmed) {
                                    this.showGuests = true
                                }
                            }
                }
            } catch (e) {
                this.statusInviteMsg = e
            }
            this.processingApi = false;
        },
        redirectHome() {
            this.$emit('clear-survey-type')
        },
        redirectToGuestInvite(url) {
            const fullUrl = url.startsWith('http') ? url : `https://${url}`;
            window.location.href = fullUrl;
        },
        redirectToCheckInfos(surveyLink) {
            if (surveyLink) {
                this.redirectToGuestInvite(surveyLink)
            } else {
                this.redirectHome()
            }
        },
        loadBiometry(surveyUserId) {
            this.loadingBiometry = true
            surveyService
                .getBiometry(surveyUserId)
                .then((res) => {
                    this.biometryData = res;
                    this.loadingBiometry = false
                    this.goToBiometry()
                })
                .catch((err) => {
                    this.biometryApiMsg = err
                    this.loadingBiometry = false
                    this.$vs.notify({
                        color: "rgb(255, 130, 0)",
                        title: this.biometryApiMsg,
                        text: ``,
                        time: 11000
                    })
                });
        },
        shareLinkToBiometry(surveyUserId, sharingGuestName) {
            this.loadingBiometryToWhats = true
            this.sharingMsg = `Convite de ${this.inviteName} para ${sharingGuestName}, cadastre sua biometria pelo link:`
            surveyService
                .getBiometry(surveyUserId)
                .then((res) => {
                    this.biometryData = res
                    this.sharingUrl = res
                    this.sharingUrlInput = res
                    this.loadingBiometryToWhats = false
                })
                .catch((err) => {
                    this.biometryApiMsg = err
                    this.loadingBiometryToWhats = false
                    this.$vs.notify({
                        color: "rgb(255, 130, 0)",
                        title: this.biometryApiMsg,
                        text: ``,
                        time: 11000
                    })
                });
        },
        shareLinkToSurvey(sharingUrl, sharingGuestName) {
            this.sharingUrl = sharingUrl
            if (!this.sharingUrl.startsWith("https://")) {
                this.sharingUrl = "https://" + this.sharingUrl;
            }
            this.sharingUrlInput = sharingUrl
            this.sharingMsg = `Convite de ${this.inviteName} para ${sharingGuestName}, confirme sua presença:`
        },
        goToBiometry() {
            window.location = this.biometryData
        },
        addGuest() {
            this.showGuests = false
            this.showAddGuestForm = true
        },
        async validateGuestForm() {
            this.processingApi = true;
            try {
                const ret = await surveyService.addGuest(this.prj, this.inviteId, this.guestName)
                if (ret.header.codigo) {
                    return this.checkInvite()
                }
            } catch (e) {
                this.statusInviteMsg = e
            }
            this.processingApi = false;
        },
        iosCopyToClipboard(el) {
            const oldReadOnly = el.readOnly
            const range = document.createRange()
            el.readOnly = false

            range.selectNodeContents(el)

            const s = window.getSelection()
            s.removeAllRanges()
            s.addRange(range)

            el.setSelectionRange(0, 999999) // A big number, to cover anything that could be inside the element.

            el.readOnly = oldReadOnly

            document.execCommand('copy') // to work on iOS

            this.sharingUrlInput = "Copiado!"
        }
    }
};
</script>

<style lang="scss" scoped>
.btn-pill {
    padding: 0.5rem;
    border-radius: 100%;
}

.c-font-sm {
    font-size: 0.8rem;
    line-height: 1.2;
}

.lock-survey-div {
    display: flex
}

.lock-survey-icon {
    height: 25px;
    margin-top: 17px;
    margin-left: 10px;
}

.div-invite {
    width: 100%;
}

.div-invite-spin {
    width: 100%;
    margin-top: 20px;
    align-items: center;
    text-align: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.loader {
    width: 100px;
}

.loader-wheel {
    animation: spin 1s infinite linear;
    border-left: 5px solid #fff;
    border-radius: 50%;
    height: 70px;
    margin-bottom: 10px;
    width: 70px;
}

.loader-wheel-black {
    border-left: 5px solid black;
}

.loader-text {
    color: #fff;
    font-size: 1.2rem !important;
    font-weight: bold !important;
}

.convite-text {
    color: #fff;
    font-size: 1.1rem !important;
    font-weight: bold !important;
}

.convite-text-email {
    color: #fff;
    background: transparent;
    border: none;
    margin-top: 12px;
    font-size: 1.2rem !important;
    font-weight: bold !important;
}

.convite-text-info {
    color: #fff;
    font-size: 1.5rem !important;
    font-weight: bold !important;
    line-height: 1.5 !important;
}

.convite-email-div {
    width: 280px;
    height: 55px;
    background: #101010;
    border-radius: 10px 0px 0px 10px;
    margin-top: 17px;
}

.convite-email-button {
    width: 70px;
    height: 55px;
    margin-top: 17px;
    background: white;
    border-radius: 0px 10px 10px 0px;
}

.convite-email-button:hover {
    cursor: pointer;
    color: green !important;

    .convite-img-button {
        width: 28px;
        margin-top: 13px;
        transition: 0.1s;
    }
}

.convite-img-button {
    width: 30px;
    margin-top: 12px;
    margin-left: 5px;
}

.loader-text:after {
    content: 'Loading';
    animation: load 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes load {
    0% {
        content: 'Carregando Informações';
    }

    33% {
        content: 'Carregando Informações.';
    }

    67% {
        content: 'Carregando Informações..';
    }

    100% {
        content: 'Carregando Informações...';
    }
}

.button-st {
    padding: 10px 20px;
    border-radius: 10px;
    background: #040404;
    color: white;
    margin-top: 20px;
    border: none;
    font-size: 0.9rem !important;
    font-weight: bold;
    outline: none;
}

.button-st-white {
    padding: 10px 20px;
    border-radius: 10px;
    background: #fff;
    color: black;
    border: none;
    font-size: 0.9rem !important;
    outline: none;
}

.button-st-white-init {
    width: 320px;
    height: 60px;
    border-radius: 10px;
    background: #fff;
    color: black;
    border: none;
    font-size: 0.9rem !important;
    outline: none;
}

.c-link {
    text-decoration: underline;
    cursor: pointer;
}

.copy-input {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    outline-width: 0px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: .25rem;
    background-color: #f8f8f8;
    font-size: 16px;
    resize: none;
    padding: 4px 16px;
    width: 250px;
}

.btn-whats {
    cursor: pointer;
    background-color: rgb(37, 211, 102);
    border-color: rgb(37, 211, 102);
    color: white;
    border-radius: .25rem;
    padding: 4px 16px;
    width: 250px;
}
</style>
